import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { ActionName } from "@faire/web/common/performance/userPerceivedLoadTiming/types";

export const useSearchPageActionName = (): ActionName => {
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (isFromDiscoverURL) {
    if (isLoggedInRetailer) {
      return "page-discover-logged-in";
    } else {
      return "page-discover-logged-out";
    }
  } else {
    if (isLoggedInRetailer) {
      return "page-search-logged-in";
    } else {
      return "page-search-logged-out";
    }
  }
};
